import validate from "/builds/se-team/deli-web-portal-front/node_modules/nuxt/dist/pages/runtime/validate.js";
import deprecated_45global from "/builds/se-team/deli-web-portal-front/app/middleware/deprecated.global.ts";
import manifest_45route_45rule from "/builds/se-team/deli-web-portal-front/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  deprecated_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/builds/se-team/deli-web-portal-front/app/middleware/auth.ts"),
  search: () => import("/builds/se-team/deli-web-portal-front/app/middleware/search.ts")
}